import { FC, useState } from 'react';

import { Button } from '@swyftx/aviary/atoms/Button';
import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
  CarouselUnstyledNext,
  CarouselUnstyledPrevious,
} from '@swyftx/aviary/atoms/ShadcnCarousel';
import { Heading } from '@swyftx/aviary/atoms/Typography';

import { ErrorBoundary } from 'react-error-boundary';
import { DashboardWidgetRowProps } from 'src/lib/dashboard/types';

import Card from './Card';
import { useCards } from './useCards';
import { useResources } from './useResources';

const GettingStarted: FC<DashboardWidgetRowProps> = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [api, setApi] = useState<CarouselApi>();

  const { items, hasItems } = useCards();
  const { dismissAll, isLoading: dismissAllLoading } = useResources('dismissAll');

  if (!hasItems) {
    return null;
  }

  const onDismissAll = () => {
    dismissAll();
  };

  return (
    <Carousel className='grid gap-12' setApi={setApi}>
      <FlexLayout alignItems='center' spacing={12} justifyContent='space-between'>
        <Heading size='h5' className='whitespace-nowrap'>
          Getting started
        </Heading>
        <FlexLayout alignItems='stretch' justifyContent='end' spacing={4}>
          <Button
            loading={dismissAllLoading}
            size='sm'
            variant='outlined'
            textAlign='center'
            onClick={onDismissAll}
            className='mr-8'
          >
            Dismiss All
          </Button>
          <CarouselUnstyledPrevious />
          <CarouselUnstyledNext />
        </FlexLayout>
      </FlexLayout>

      <CarouselContent className='-ml-16'>
        {items.map((item) => (
          <CarouselItem key={item.id} className='flex pl-16 @sm:basis-1/2 @md:basis-1/3 @lg:basis-1/4'>
            <Card {...item} />
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
};

export default function GettingStartedWrapper() {
  return (
    // Error boundary for catching errors in the GettingStarted component, this stops the entire dashboard from crashing
    // and allows the rest of the dashboard to function normally.
    // The fragment here is used until we have a proper error component style to show.
    // TODO update the error component fallback with a new error component when we have error component styles ready
    <ErrorBoundary fallback={<></>}>
      <GettingStarted />
    </ErrorBoundary>
  );
}
